import React, { useState, useEffect } from 'react';
import { BsEmojiAngry, BsEmojiFrown, BsEmojiNeutral, BsEmojiSmile, BsEmojiLaughing } from 'react-icons/bs';
import './csat.css';

export default function CSATComponent({ onClose }) {
    const [visible, setVisible] = useState(false);
    const [response, setResponse] = useState(null); // 'sim', 'não' ou null
    const [feedback, setFeedback] = useState('');
    const [expandedMode, setExpandedMode] = useState(false);
    const [rating, setRating] = useState(null); // Armazena a classificação com emoji (1-5)

    const isAreaLogada = typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('origem') === 'area_logada';

    useEffect(() => {
        // Inicia a animação após o componente ser montado
        setTimeout(() => {
            setVisible(true);
        }, 5);
    }, []);

    const handleResponse = (responseValue) => {
        if (responseValue === 'closed') {
            // Fechar o componente
            closeComponent(responseValue);
        } else if (responseValue === 'não' || responseValue === 'sim') {
            // Armazena a resposta e ativa o modo expandido
            setResponse(responseValue);
            // Pequeno delay para a transição ser mais suave
            setTimeout(() => {
                setExpandedMode(true);
            }, 50);
        }
    };

    const closeComponent = (responseValue) => {
        // Fecha o componente com uma animação
        setVisible(false);
        setTimeout(() => {
            onClose(responseValue);
        }, 300); // Tempo para a animação de saída
    };

    const handleSubmitFeedback = () => {
        // Aqui você pode fazer a chamada da API com o feedback
        console.log(`Feedback enviado: Resposta ${response}, Rating ${rating}, Comentário: ${feedback}`);
        closeComponent({ response, rating, feedback });
    };

    const handleRatingClick = (value) => {
        setRating(value);
    };

    const renderEmoji = (option) => {
        if (isAreaLogada) {
            const size = 32;
            switch(option.value) {
                case 1: return <BsEmojiAngry size={size} />;
                case 2: return <BsEmojiFrown size={size} />;
                case 3: return <BsEmojiNeutral size={size} />;
                case 4: return <BsEmojiSmile size={size} />;
                case 5: return <BsEmojiLaughing size={size} />;
                default: return option.emoji;
            }
        }
        return option.value === 3 ? '😌' : option.emoji;
    };

    // Mapeamento dos emojis e seus textos
    const ratingOptions = [
        { value: 1, emoji: '😠', text: 'Muito ruim' },
        { value: 2, emoji: '🙁', text: 'Ruim' },
        { value: 3, emoji: '😌', text: 'Regular' },
        { value: 4, emoji: '🙂', text: 'Bom' },
        { value: 5, emoji: '😍', text: 'Muito bom' }
    ];

    return (
        <>
            <div className={`csat-overlay ${visible ? 'visible' : ''}`} onClick={() => handleResponse('closed')}></div>
            <div className={`csat-container ${visible ? 'visible' : ''} ${expandedMode ? 'expanded' : ''}`}>
                
                {!expandedMode && (
                    <>
                        <div className="csat-header">
                            <span>Encontrou o que procurava?</span>
                            <button className="close-button" onClick={() => handleResponse('closed')}>
                                &times;
                            </button>
                        </div>
                        
                        <div className="csat-buttons">
                            <button 
                                className="csat-button negative" 
                                onClick={() => handleResponse('não')}
                            >
                                Não
                            </button>
                            <button 
                                className="csat-button positive" 
                                onClick={() => handleResponse('sim')}
                            >
                                Sim
                            </button>
                        </div>
                    </>
                )}

                {expandedMode && (
                    <div className="csat-feedback">
                        <button className="close-button feedback-close" onClick={() => handleResponse('closed')}>
                            &times;
                        </button>
                        <h3>O que você achou de usar o Assistente Virtual?</h3>
                        
                        <div className="rating-container">
                            {ratingOptions.map((option) => (
                                <div 
                                    key={option.value}
                                    className={`rating-option ${rating === option.value ? 'selected' : ''}`}
                                    onClick={() => handleRatingClick(option.value)}
                                >
                                    <div className="emoji">{renderEmoji(option)}</div>
                                    <div className="rating-text">{option.text}</div>
                                </div>
                            ))}
                        </div>
                        
                        <p className="feedback-label">Quer contar algo mais?</p>
                        <textarea 
                            value={feedback}
                            onChange={(e) => setFeedback(e.target.value)}
                            placeholder=""
                            rows="6"
                            className={`feedback-textarea ${!rating ? 'disabled' : ''}`}
                            disabled={!rating}
                        ></textarea>
                        <button 
                            className="feedback-submit-button"
                            onClick={handleSubmitFeedback}
                            disabled={!rating}
                        >
                            Enviar
                        </button>
                    </div>
                )}
            </div>
        </>
    );
} 